import { doAttention } from '@/attention';
export function jello(el, duration = undefined, options = {}) {
    return doAttention(el, 'jello', duration, options);
}
//# sourceMappingURL=jello.js.map